// src/App.js
import React from "react";

function Failure() {
  return <div>Başarısız</div>;
}

export default Failure;
